<div id="errorpage">
	<div class="errorpage">
		<h2>500 - Server error</h2>
		<p>Sorry, we had some technical problems during your last operation.</p>
		<button type="button" (click)="goHome()">Go To Homepage</button>
	</div>
</div>